import _ from 'lodash';

const NEW_ELEMENT_PREFIX = `element${Math.random().toString(36).substring(7)}_`;

let uniqueElementId = 0;

const setUniqueElementId = (elements) => {
  let lastId = 0;
  if (!_.isEmpty(elements)) {
    lastId = _.reduce(_.keys(elements), (maxElementId, elementIdStr) => {
      const elementId = parseInt(elementIdStr.replace(/[^\d]+/, ''), 10);
      return elementId > maxElementId ? elementId : maxElementId;
    }, 0);
  }
  uniqueElementId = lastId;
};

const generateElementId = (elements) => {

  if (uniqueElementId === 0) {
    setUniqueElementId(elements);
  }

  uniqueElementId++;
  return NEW_ELEMENT_PREFIX + uniqueElementId;
};

export {
  generateElementId
};
